import { useState } from "react";

/**
 * Step 3 — name + optional email so receipts/PDFs are personalised.
 * `onSubmit({name, email})` is wired from the parent; "Skip" uses the same
 * handler with empty strings so the backend creates a phone-only profile.
 */
export default function ProfileStep({ err, loading, onSubmit }) {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");

  return (
    <form
      onSubmit={(e) => { e.preventDefault(); onSubmit({ name, email }); }}
      className="space-y-4"
    >
      <p className="text-sm text-muted-foreground">One last step — so we can personalise your reports.</p>
      <label className="block">
        <span className="eyebrow block mb-2">Your name</span>
        <input
          type="text"
          autoFocus
          value={name}
          onChange={(ev) => setName(ev.target.value)}
          placeholder="Aarav Sharma"
          className="input-dark w-full px-3 py-2.5 text-sm"
          data-testid="phone-otp-name-input"
        />
      </label>
      <label className="block">
        <span className="eyebrow block mb-2">
          Email <span className="text-muted-foreground normal-case">(optional — for PDFs &amp; receipts)</span>
        </span>
        <input
          type="email"
          value={email}
          onChange={(ev) => setEmail(ev.target.value)}
          placeholder="you@example.com"
          className="input-dark w-full px-3 py-2.5 text-sm"
          data-testid="phone-otp-email-input"
        />
      </label>
      {err && <div className="text-sm text-destructive" data-testid="phone-otp-error">{err}</div>}
      <button
        type="submit"
        disabled={loading}
        className="btn-primary w-full py-3 text-sm"
        data-testid="phone-otp-finish-btn"
      >
        {loading ? "Finishing…" : "Enter Estima"}
      </button>
      <button
        type="button"
        onClick={() => onSubmit({ name: "", email: "" })}
        disabled={loading}
        className="btn-ghost w-full py-2 text-xs"
        data-testid="phone-otp-skip-profile"
      >
        Skip — I'll add later
      </button>
    </form>
  );
}
